import { Header } from "@fc/devteam-components-library";
import HeaderGuestI from '@interfaces/header-guestI';
import { useNavigate } from 'react-router-dom';
import SessionData from './session-data';
import SessionDataBtn from './session-data-btn';
import { Dispatch, SetStateAction, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCalendarHeaderOfficeFilterState, setCalendarHeaderServiceFilterState, setCalendarHeaderStatusFilterState, setCalendarHeaderViewState } from '@redux/slices/calendar/header/calendar-header.slice';
import { RootState } from '@redux/store';
import { AppointmentI } from '@interfaces/scheduller/appointmentsI';
import Badge from '@material-ui/core/Badge';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import dayjs from 'dayjs';
import useCallSocket from '@customHooks/voice-call/use-call-socket';
import { SocketContext } from '@modules/practitioner/practitioner-module';
import { readPractitionerProfile } from '@services/signup';
import { IChatCustom, IContact, IHandlers, IhandlerType, IMessage, IRequest, IStatus, IUnreadMessages, PlatformRole } from '@interfaces/chat/chatI';
import { checkConnection, initCommunication, login, logout } from '@functions/chat-controller/chatController';
import { setMessageSocketQueue } from '@redux/slices/socketChat/chatMessages';
import { setContactSocketQueue } from '@redux/slices/socketChat/chatContacts';
import { setChatSocketQueue } from '@redux/slices/socketChat/chatChats';
import { setLogged } from '@redux/slices/socketChat/loggedValidation';
import { IChatArriveMessageIrdx } from '@interfaces/redux/base-state';
import { setChatNewMessageFlag } from '@redux/slices/socketChat/chatMessageArrive-slice';
import addNotification from 'react-push-notification';
import { playSound } from '@controllers/sound-controller';
import { setChatContactStatus } from '@redux/slices/socketChat/chatStatus';
import { getChatSettings } from '@services/chat/chat_config';
import useVideoCallSocket from '@customHooks/video-call/use-videocall-socket';
import { VideoCallSocketContext } from "@contexts/videocall";
import { removeUnreadMessages, setUnreadMessages } from '@redux/slices/socketChat/chatUnreadMessages';
import { getPermissions } from '@services/fc-user/permissions';
import { IPermission, Scope } from '@interfaces/fc-user/permissions';
import { mergeUserRolesGlobal } from '@functions/permissions/permissionsFunctions';
import { Socket } from 'socket.io-client';
import CallCountdownTimerVoice from '@components/voice-call/components/CallCountdownTimer';
import CallCountdownTimerVideo from '@components/video-call/components/CallCountdownTimerVideo';
import { VoiceCallContext } from '@contexts/voiceCallContext';
import HeaderLogo from "./header-logo";
import SaludProxApps from "./salud-prox-apps";
import useOutsideClick from "@customHooks/use-outside-click";
import { getSubdomainByLocation } from "@functions/getSubDomainSalud";
import useUserChatConfig from "@customHooks/chat/useUserChatConfig";
import { OrganizationCalendarI } from "@interfaces/organizationI";

export interface PractitionerHeaderI extends HeaderGuestI {
    hide: boolean;
    setHide: Dispatch<SetStateAction<boolean>>;
}

/**
 * Main header
 * @param props 
 * @returns 
 */
const HeaderPractitioner = (props: PractitionerHeaderI) => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation(['mySchedule','calendar','chat'])
    const lang = i18next.language;
    const practitionerAppointmentsToBeConfirmed = useSelector((state: RootState) => state.practitionerAppointmentsToBeConfirmed);
    const CalendarHeaderRe = useSelector((state: RootState) => state.calendarHeaderRe);
    const { loggedInValidation } = useSelector((state: RootState) => ({loggedInValidation:state.loggedInValidation.loggedIn}))
    const [titleText, setTitleText] = useState<string>('')
    const [totalAppoimentsTobeConfirmed, setTotalAppoimentsToBeConfirmed] = useState<number>(0)
    const { emitSocketEvent } = useCallSocket();
    const { emitSocketVideoEvent } = useVideoCallSocket();
    const { socket } = useContext(SocketContext);
    const { socketVideo } = useContext(VideoCallSocketContext)
    const {messageArrive } = useSelector((state: RootState) => ({messageArrive:state.chatArrive}));
    const [hiddenNewMessageNot, setHiddenNewMessageNot] = useState(true)
    const voiceAlert = useSelector((state: RootState) => state.voiceAlert)
    const [hiddenNewCallNot, setHiddenNewCallNot] = useState<boolean>(false)
    const {organization, session: sessionData} = useSelector((state: RootState) => ({organization: state.organizations, session: state.session}));
    const practitioner = useSelector((state: RootState) => state.practitionerProfile.profile)
    const today = new Date();
    const unreadMessages = useSelector((state: RootState) => state.messageSocketUnreadMessage.unreadMessages);
    const [openAppsCard, setOpenAppsCard] = useState<boolean>(false)
    const [permissionsReports, setPermissionsReports] = useState<IPermission[]>([])
    
    const currentVoiceCall = useSelector((state: RootState) => state.voiceCall)
    const currentVideoCall = useSelector((state: RootState) => state.videoCall)
    const { counterIsAllowed, resetStates } = useContext(VoiceCallContext)
    const { showTimer } = useContext(VideoCallSocketContext)
    const container = useRef() as React.MutableRefObject<HTMLDivElement>

    const { configData, reloadData: reloadConfigData } = useUserChatConfig()


    const loginSocketProcess = useCallback(async(initial?:boolean) => { // Function to send login to the socket and provide it with user information
        const configDataRes = await getChatSettings(sessionData.username ?? '', "PR")
        if( (initial && configDataRes.defaultChatLogin === "CONNECTED") || !initial){
            const practitionerProfileResponse = await readPractitionerProfile(
                sessionData.username ?? ''
            );
            const userConnect: IContact = {  // Log in user information will be created
                id: String(practitionerProfileResponse.personId) ?? '',
                username: sessionData.username ?? '',
                email: sessionData.email ?? '',
                name: `${practitionerProfileResponse.name !== null ? practitionerProfileResponse.name : sessionData.username }${practitionerProfileResponse.secondName ? ' ' + practitionerProfileResponse.secondName : ''} ${practitionerProfileResponse.lastName !== null ? practitionerProfileResponse.lastName : ''}${practitionerProfileResponse.secondLastName ? ' ' + practitionerProfileResponse.secondLastName : ''}`,
                platformRole: PlatformRole.PR, // The socket will be told that the user is a practitioner.
                isDependent: false,
            }
    
            const request: IRequest = {
                contact: userConnect,
                loadRich: true,
                appOrigin: getSubdomainByLocation() //Get the platform's Scope
            }
            await logout({}); // Logout to avoid double data
            const loginSOcket = await login(request);
            if(loginSOcket) //
                dispatch(setLogged(true));
        }
    }, [dispatch, sessionData.email, sessionData.username]);

    /**
    * Handle new connection
    */
    const onConnected = (initial = false) => { // Function that will be listening when the socket is successfully connected
        console.debug("Chat socket: On connected");
        if (initial)
            reloadConfigData();
        // checkInitial(initial);
        if (!initial)
            loginSocketProcess();
    }

    const onChatChangeFunction = async(chat: IhandlerType<IChatCustom>) => { // Function that will be listening when a chat changes its information
        // console.log("chat:", chat)
        if(chat.type === "added" || chat.type === "modified"){
            dispatch(setChatSocketQueue(chat.data))
        }
    }

    //This is used for chat
    const onMessagechangeFunction = (message: IhandlerType<IMessage>) => { // Function for listen messages from the socket
        // console.log("Mensaje:", message)
        if(!message.data.date) return;
        const messageDate = new Date(message.data.date)
        if(message.type === "added" && today.getTime() < messageDate.getTime()){
            dispatch(setMessageSocketQueue(message.data))
        }
    }

    const onContactChangeFuncction = (contact: IhandlerType<IContact>) => { // Function that will be listening when a contact changes its information
        // console.log("CONTACT", contact)
        if((contact.type === "added" || contact.type === "modified") && 
            contact.data?.platformRole === PlatformRole.PA)
            dispatch(setContactSocketQueue(contact.data))
    }
    
    const onStatusChangeFunction = (status: IhandlerType<IStatus>) => { //Function that will be listening when a contact changes its connected status
        // console.log("status:", status)
        if(status.type === "added" || status.type === "modified")
            dispatch(setChatContactStatus(status.data))
    }
    const onUnreadMessageFunction = (message: IhandlerType<IUnreadMessages>) => { // Function that will be listening when a new unread message arrives
        // console.log('Unread message', message);
        if (message.type === 'added') {
            dispatch(setUnreadMessages(message.data));
            addNotification({
                title: 'Nuevo mensaje - SaludProx',
                subtitle: 'SaludProx',
                message: 'Tienes un nuevo mensaje',
                theme: 'light',
                duration: 10000,
                onClick: goChat,
                closeButton: 'Cerrar',
                native: true, // when using native, your OS will handle theming.
            });

            playSound("message") // It will emit the new message sound

            if (window.location.pathname.includes('chat')) { // // If we are in the chat, hide the new messages component
                setHiddenNewMessageNot(true);
            } else {
                setHiddenNewMessageNot(false);
            }
            const newMessageState: IChatArriveMessageIrdx = {
                arriveMessage: true,
            };
            dispatch(setChatNewMessageFlag(newMessageState));
        } else if (message.type === 'removed') {
            dispatch(removeUnreadMessages(message.data));
        }
    };

    // TODO: Consider moving the handlers to their own file.
    const handlers: IHandlers = { // List of listening functions provided to the socket
        onConnected: onConnected,
        onChatChange: onChatChangeFunction,
        onMessageChange: onMessagechangeFunction,
        onContactChange: onContactChangeFuncction,
        onStatusChange:  onStatusChangeFunction,
        onUnreadMessages: onUnreadMessageFunction,
    }   

    const handleAppsCard = (statusOpen: boolean) => {
        setOpenAppsCard(statusOpen)
    }

    const goCalendar = () =>{
        dispatch(setCalendarHeaderStatusFilterState({
            statusFilter:'toBeConfirmed'
        }));
        dispatch(setCalendarHeaderViewState({
            viewFilter:'schedule'
        }));
        dispatch(setCalendarHeaderOfficeFilterState({
            officeFilter:"schedule"
        }));
        dispatch(setCalendarHeaderServiceFilterState({
            serviceFilter:'schedule'
        }));
        history('/practitioner/calendar');
    }

    const goChat = () =>{
        history('/practitioner/chat');   
    }

    /**
     * @deprecated Move to custom hook
     */
    const manageGetRoles = async (roles: string[] | undefined , scope:Scope) => {
        if(roles){
            switch (scope) {
                case 'reports':{
                    const permissionDefaulReports = await mergeUserRolesGlobal(roles, 'reports')
                    setPermissionsReports(permissionDefaulReports)
                    break;
                }
                default:
                    break;
            }
        }
    }


    /**
     * @deprecated Move to custom hook
     */
    const getPermissionsByUser = async (username: string) => {
        try {
            const permissions = await getPermissions(username, organization.organizationId, ['drProx', 'reports'])
            return permissions
        } catch (error) {
            console.error(error)
            return undefined
        }
    }

    /**
     * @deprecated Move to custom hook
     */
    const getUserPermissions = async (org:OrganizationCalendarI) =>{
        // const roles = await getRolesOrganization()
        const roles = org.roles
        if(roles && roles.length && practitioner.email !== null){
            const permissionUser = practitioner ? await getPermissionsByUser(practitioner.email) : undefined
            if(permissionUser){
                permissionUser.reports ? setPermissionsReports(permissionUser.reports) :  manageGetRoles(roles,'reports')
            }else{
                if(roles.length > 0){
                    manageGetRoles(roles,'reports')
                }
            }
        }
    }

    useOutsideClick(container, () => {
        handleAppsCard(false);
    });

    const handleSocket = async (socket: Socket, connect: boolean, type: 'video' | 'voice' ) =>{
        if(connect){
            socket.on("connect", () => {
                console.debug(`${type} socket: connected`);
                if(type === 'voice'){
                    emitSocketEvent('create_user', {username: sessionData.username, name: `${practitioner.name} ${practitioner.lastName}`, role: 'PR'})
                }else {
                    emitSocketVideoEvent('create_user', {username: sessionData.username, name: `${practitioner.name} ${practitioner.lastName}`, role: 'PR'});
                }
            });

            socket.on("disconnect", function() {
                console.warn(`${type} socket: Disconnected`);
                resetStates()
            });
            socket.connect()
        }else{
            if(socket) {
                socket.removeAllListeners("connect");
                socket.removeAllListeners("disconnect");
                socket.disconnect()   
            }
        }
    }

    useEffect(() => { // 
        const login = configData?.defaultChatLogin === "CONNECTED"; // It is managed if a login process is performed depending on the professional's configuration.
        if (login) {
            loginSocketProcess();
        }else{
            dispatch(setLogged(false));
        }
    }, [configData, dispatch, loginSocketProcess]);

    useEffect(()=>{
        const checkSocketChatConnection = async (initial?: boolean) =>{ // It is managed if there is already a connection with the socket or only issue the login
            console.log("checkSocketChatConnection initial: ",initial)
            if (!sessionData) return; // Verify that user information exists in DrProx
            if (!sessionData.userId) return;
            const conexion = checkConnection(); // Check if a connection already exists on the socket
            if (!conexion || (conexion && !conexion.connected)) {
                await initCommunication(
                    sessionData.userId, // user id in db
                    handlers,// List of socket listening handlers
                    {
                        loginAvailable: sessionData.email !== null,
                        initial: initial
                    }
                )
            }else{
                // console.log("conexion ya existia ",)
                if (conexion && sessionData.email !== null) {
                    loginSocketProcess()
                }
            }
        }
        checkSocketChatConnection(true);

        window.addEventListener("loginremote", () => checkSocketChatConnection(false)); // This event is triggered from the chat when you become 'online' again.
        return () => {
            window.removeEventListener("loginremote", () => checkSocketChatConnection(false));
        };
        // eslint-disable-next-line
    },[])

    useEffect(()=>{
        if(organization){
            getUserPermissions(organization)
        }
        // eslint-disable-next-line
    }, [organization])

    useEffect(()=>{
        if (practitionerAppointmentsToBeConfirmed.practitionerAppointmentsToBeConfirmed.length > 0) {
            let newArray:AppointmentI[] = []
            practitionerAppointmentsToBeConfirmed.practitionerAppointmentsToBeConfirmed.forEach((appointment, index) => {
                newArray[index] = { ...appointment }
            })
            newArray = newArray.sort(((a, b) => a.appointmentDateTimestamp - b.appointmentDateTimestamp))
            let countConfirmed = 0, textDate = "";
            newArray.map((appoiment: AppointmentI, i) => {
                if (appoiment.statusAppointment === "toBeConfirmed") {
                    if(countConfirmed === 0){
                        const appointmentDay = dayjs(new Date(appoiment.appointmentDateString)).format('D')
                        const appointmentMonth = t(`calendar:monthsAbbreviated.${dayjs(new Date(appoiment.appointmentDateString)).format('MMM').toUpperCase()}.long`)
                        const appointmentYear = dayjs(new Date(appoiment.appointmentDateString)).format('YYYY')
                        const appointmentDate = appointmentDay + "-" + appointmentMonth + "-" + appointmentYear
                        textDate = appointmentDate
                    }
                    countConfirmed++

                    if (newArray.length === (i + 1)) {
                        const appointmentDay = dayjs(new Date(appoiment.appointmentDateString)).format('D')
                        const appointmentMonth = t(`calendar:monthsAbbreviated.${dayjs(new Date(appoiment.appointmentDateString)).format('MMM').toUpperCase()}.long`)
                        const appointmentYear = dayjs(new Date(appoiment.appointmentDateString)).format('YYYY')
                        const appointmentDate = appointmentDay + "-" + appointmentMonth + "-" + appointmentYear
                        const selectedDateName = dayjs(CalendarHeaderRe.date).format("D") + "-" + t(`calendar:monthsAbbreviated.${dayjs(CalendarHeaderRe.date).format('MMM').toUpperCase()}.long`) + "-" + dayjs(CalendarHeaderRe.date).format("YYYY")
                        setTitleText(`${t(`mySchedule:appointmentsToBeConfirmed.textRange.of`)} ${textDate} ${t(`mySchedule:appointmentsToBeConfirmed.textRange.to`)} ${appointmentDate}`)
                    }
                } 
                return countConfirmed
            })
            setTotalAppoimentsToBeConfirmed(countConfirmed)
        }else{
            setTotalAppoimentsToBeConfirmed(0)
        }
        // eslint-disable-next-line 
    },[practitionerAppointmentsToBeConfirmed, lang])

    useEffect(() => {
        // console.log("chatConfig , redux: ",chatConfig)
        if(configData?.activeVoiceCall && loggedInValidation && socket) {
            handleSocket(socket, true,'voice');
            if(socketVideo){
                handleSocket(socketVideo, true,'video');
            }
        }
        if(!configData?.activeVoiceCall || !loggedInValidation){
            if(socket) {
                handleSocket(socket, false,'voice');
            }
            if(socketVideo){
                handleSocket(socketVideo, false,'video');
            }
        }
        return () => {
            if(socket) {
                handleSocket(socket, false,'voice');
            }
            if(socketVideo){
                handleSocket(socketVideo, false,'video');
            }
        }
         // eslint-disable-next-line
    }, [configData, loggedInValidation]);

    useEffect(()=>{
        if(messageArrive.arriveMessage){
            if(window.location.pathname.includes('chat')){
                setHiddenNewMessageNot(true)
            }else{
                setHiddenNewMessageNot(false)
            }
        }
        else{
            setHiddenNewMessageNot(true)
        }
        // eslint-disable-next-line 
    },[messageArrive.arriveMessage])

    //unread message listener
    useEffect(() => {
        if(unreadMessages.length === 0)
            setHiddenNewMessageNot(true)
    }, [unreadMessages])

    useEffect(() => {
        if(voiceAlert && voiceAlert.voiceAlert){
            setHiddenNewCallNot((voiceAlert.voiceAlert.newCall?? false) && (voiceAlert.voiceAlert.callinprocess?? false))
        }
    }, [voiceAlert]);

    return (
        <Header 
            logoElement={<HeaderLogo hide={props.hide} setHide={props.setHide} />}
        >
            <div className="HeaderButtons">
            {/* { new Date().getDay() === 4 && <UpdateAlert /> } */}
                {/* <WalkthroughSteps /> */}
                {totalAppoimentsTobeConfirmed > 0 &&
                    // <>
                        <Badge badgeContent={totalAppoimentsTobeConfirmed} title={titleText} color="error"sx={{color: 'red', cursor: "pointer" }} max={500} onClick={() => goCalendar()}> 
                            <div className="Menu__SectionsItemIcon">
                                <em className="fad fa-calendar-alt"></em>
                            </div>
                        </Badge >
                    // </>
                }         
                {!hiddenNewMessageNot &&
                    <Badge invisible={false} variant="dot" color="error" sx={{ cursor: "pointer" }} onClick={() => goChat()}>
                        <div className="Menu__SectionsItemIcon">
                            <em className="fa fa-message"/>
                        </div>
                    </Badge >
                }
                {hiddenNewCallNot && currentVoiceCall?.call !== undefined ?
                    <div className="Chat__CallContainer">
                        <div className="Chat__Calling">
                            <div className="Chat__CallingProcess" onClick={() => goChat()}>
                                <em className="fa fa-phone-volume" />
                                <p className="Chat__CallingProcess-Text">
                                    {t('chat:calls.callInProgress')}
                                    {counterIsAllowed &&
                                        <CallCountdownTimerVoice />
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {currentVideoCall?.videoCall !== undefined ?
                        <div className="Chat__CallContainer">
                        <div className="Chat__Calling">
                            <div className="Chat__CallingProcess" onClick={() => goChat()}>
                                <em className="fa fa-video" />
                                <p className="Chat__CallingProcess-Text">
                                    {t('chat:calls.callInProgress')}
                                    {showTimer &&
                                        <CallCountdownTimerVideo />
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div className="HeaderApps__Container" ref={container}>
                    <div className='HeaderApps' onClick={()=>handleAppsCard(!openAppsCard)}>
                        <i className="fas fa-grid"/>
                    </div>
                    {openAppsCard ?
                        <SaludProxApps
                        permissionsReports={permissionsReports}
                        organizationId={organization.organizationId}
                        setOpenAppsCard={handleAppsCard}
                        />
                        : <> </>
                    }
                </div>
                {/* <div className="HeaderUser" onClick={() => goToServices()}>
                    <div className="HeaderUser__Avatar">
                        <em className="fas fa-question" />
                    </div>
                    <div className="HeaderUser__Arrow"></div>
                </div> */}
                <div className={props.classSection2}>
                    <SessionData />
                </div>
                <div className={'HeaderButtonCtr'}>
                    <SessionDataBtn />
                </div>
            </div>
        </Header>
    );
};

export default HeaderPractitioner;
